import { hexToRgba } from '../palette';

export const MuiDataGrid = (mode) => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: theme.shape.borderRadius * 2,
          backgroundColor: theme.palette.background.paper,
          fontSize: "0.875rem",
          "& .MuiDataGrid-main": {
            borderRadius: theme.shape.borderRadius * 2,
          },
          "& .MuiDataGrid-cell": {
            minHeight: 'unset !important',
            maxHeight: 'none !important',
            height: 'auto !important',
            display: 'flex !important',
            alignItems: 'center !important',
            lineHeight: '1.5 !important',
            borderColor: theme.palette.divider,
            padding: "12px 16px",
            "&:focus": {
              outline: `2px solid ${theme.palette.primary.main}`,
              outlineOffset: "-2px",
            },
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alternate,
            borderColor: theme.palette.divider,
            borderBottom: `2px solid ${theme.palette.divider}`,
            fontSize: "0.875rem",
            fontWeight: 500,
            color: theme.palette.text.secondary,
          },
          "& .MuiDataGrid-columnHeader": {
            borderColor: theme.palette.divider,
            "&:focus": {
              outline: "none",
            },
            "&:focus-within": {
              outline: `2px solid ${theme.palette.primary.main}`,
              outlineOffset: "-2px",
            },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 600,
            // textTransform: "uppercase",
            letterSpacing: "0.5px",
          },
          "& .MuiDataGrid-columnSeparator": {
            color: theme.palette.divider,
          },
          "& .MuiDataGrid-row": {
            "&:hover": {
              backgroundColor: hexToRgba(theme.palette.primary.main, 0.06),
            },
          },
          "& .MuiDataGrid-footerContainer": {
            borderColor: theme.palette.divider,
            backgroundColor: theme.palette.background.paper,
          },
          "& .MuiDataGrid-selectedRowCount": {
            color: theme.palette.text.secondary,
          },
          "& .MuiTablePagination-root": {
            color: theme.palette.text.primary,
          },
          "& .MuiTablePagination-selectIcon": {
            color: theme.palette.text.primary,
          },
        }),
      },
    },
  };
};